/**
 * Copia um texto. Tenta a área de transferência do navegador e, onde ela é
 * recusada (algumas telas embutidas), copia por um campo escondido. Lança erro
 * quando nenhuma das duas funciona, para a tela não dizer "Copiado" à toa.
 */
export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    /* segue para o campo escondido */
  }
  const field = document.createElement('textarea');
  field.value = text;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.opacity = '0';
  field.style.pointerEvents = 'none';
  document.body.appendChild(field);
  field.select();
  try {
    if (!document.execCommand('copy')) throw new Error('copy_failed');
  } finally {
    field.remove();
  }
}
